import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { EmotionSection } from './components/EmotionSection';
import { DifferenceSection } from './components/DifferenceSection';
import { HowItWorks } from './components/HowItWorks';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { TestimonialSection } from './components/TestimonialSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyPhoneBar } from './components/StickyPhoneBar';
import { ConsultationFormProvider } from './components/ConsultationFormContext';
import { ConsultationFormModal } from './components/ConsultationFormModal';
export function App() {
  return <ConsultationFormProvider data-id="element-0">
      <div className="min-h-screen bg-warm-bg text-text-dark font-sans selection:bg-gold/20 selection:text-text-dark pb-14" data-id="element-1">
        <Header data-id="element-2" />

        <main data-id="element-3">
          <HeroSection data-id="element-4" />
          <BeforeAfterSection data-id="element-5" />
          <EmotionSection data-id="element-6" />
          <DifferenceSection data-id="element-7" />
          <HowItWorks data-id="element-8" />
          <TestimonialSection data-id="element-9" />
          <FAQSection data-id="element-10" />
          <FinalCTA data-id="element-11" />
        </main>

        <Footer data-id="element-12" />
        <StickyPhoneBar data-id="element-13" />
        <ConsultationFormModal data-id="element-14" />
      </div>
    </ConsultationFormProvider>;
}